import { isNumeric } from './isNumeric';

export const toNumber = (maybeNumber: string | null | undefined): number | undefined => {
  if (!isNumeric(maybeNumber)) {
    return undefined;
  }

  return Number(maybeNumber);
};
